<template>
  <div>
    <div class="row">
      <div class="flex xs10 offset--xs1">
        <va-card :title="title">
          <div class="row">
            <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
            <div class='flex md12 sm6 xs12'>
              <va-input
                v-model='insertData.videoId'
                v-show="showUid"
                label='videoId'
                disabled
              />
            </div>
            <div class='flex md12 sm6 xs12'>
              <va-input
                v-model='insertData.serviceId'
                label='课程id'
                disabled
              />
            </div>
            <div class="flex md6 sm6 xs12">
              <va-input
                label="视频名称"
                v-model="insertData.videoName"
                removable
                :messages="message"
                :error="!!error.videoNameErrors.length"
                :error-messages="error.videoNameErrors"
              />
            </div>
            <div class="flex md6 sm6 xs12">
              <va-input
                label="视频名称(英文)"
                v-model="insertData.videoNameEn"
                removable
                :messages="message"
                :error="!!error.videoNameEnErrors.length"
                :error-messages="error.videoNameEnErrors"
                success
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.videoUrl"
                label="视频url"
                :messages="['请在下方OSS云端视频列表中选择']"
                removable
                disabled
              />
            </div>

            <!--    视频      -->
            <!--            <va-progress-bar-->
            <!--              :buffer="videoUploadPercent"-->
            <!--              v-show="videoFlag"-->
            <!--              class="flex md sm6 xs12"-->
            <!--            >{{this.videoUploadPercent}}%</va-progress-bar>-->
            <div class='flex md12 sm6 xs12' v-show="insertData.videoUrl.length!==0">
              <video
                :src="insertData.videoUrl"
                loop="loop"
                width="500px"
                controls="controls"
                class="section-background-video"
              >
                <source
                  type="video/mp4"
                  :src="insertData.videoUrl"
                />
              </video>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.videoUrlEn"
                label="视频url(英文)"
                :messages="['请在下方OSS云端视频列表中选择']"
                removable
                disabled
                success
              />
            </div>

            <!--    视频      -->
            <!--            <va-progress-bar-->
            <!--              :buffer="videoUploadPercent"-->
            <!--              v-show="videoFlag"-->
            <!--              class="flex md sm6 xs12"-->
            <!--            >{{this.videoUploadPercent}}%</va-progress-bar>-->
            <div class='flex md12 sm6 xs12' v-show="insertData.videoUrlEn.length!==0">
              <video
                :src="insertData.videoUrlEn"
                loop="loop"
                width="500px"
                controls="controls"
                class="section-background-video"
              >
                <source
                  type="video/mp4"
                  :src="insertData.videoUrlEn"
                />
              </video>
            </div>
            <div class="flex md6 sm6 xs12">
              <va-input
                v-model="insertData.sortNum"
                label="排序"
                placeholder="数字越大越靠前"
                removable
                type="number"
                oninput="if(value <0)value=1"
                :min="1"
                :messages="message"
                :error="!!error.sortNumErrors.length"
                :error-messages="error.sortNumErrors"
              />
            </div>
            <div class="flex md6 sm6 xs12" v-show="!!this.insertData.duration">
              <va-input
                label="视频时长"
                v-model="insertData.duration"
                disabled
                :messages="['自动填充']"
                :error="!!error.durationErrors.length"
                :error-messages="error.durationErrors"
              />
            </div>
            <div class="flex md6 sm6 xs12">
              <va-input
                v-model="insertData.createTime"
                v-show="showCreateTime"
                label="创建时间"
                disabled
              />
            </div>
          </div>
          <div class="flex md2 offset--md5">
            <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
              submit
            </va-button>
          </div>
        </va-card>
      </div>
    </div>
    <div class="row">
      <div class="flex xs10 offset--xs1">
        <va-card title="OSS云端视频列表">
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="originalName"
              placeholder="搜索视频名称"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <va-data-table
            :fields="fields"
            :data="ossFiles"
            :loading="loading"
            api-mode
          >
            <template slot="actions" slot-scope="props">
              <va-button
                small
                color="info"
                @click="selectVideo(props.rowData.url)"
                v-if="insertData.videoUrl === props.rowData.url">选择中文视频</va-button>
              <va-button
                small
                outline
                color="info"
                @click="selectVideo(props.rowData.url)"
                v-else>选择中文视频</va-button>
              <va-button
                small
                color="info"
                @click="selectVideoEn(props.rowData.url)"
                v-if="insertData.videoUrlEn === props.rowData.url">选择英文视频</va-button>
              <va-button
                small
                outline
                color="info"
                @click="selectVideoEn(props.rowData.url)"
                v-else>选择英文视频</va-button>
            </template>
          </va-data-table>

        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime, translateData } from '@/utils/common'
import videoApi from '../../api/video'
import ossApi from '@/api/oss'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      insertData: {
        id: null,
        videoId: null,
        videoName: '',
        videoNameEn: '',
        serviceId: this.$route.query.serviceId,
        serviceType: this.$route.query.serviceType,
        duration: '0:00',
        videoUrl: '',
        videoUrlEn: '',
        videoUrlArr: [],
        videoUrlEnArr: [],
        sortNum: 1,
        createTime: '',
      },
      message: ['Required field'],
      error: {
        videoNameErrors: [],
        videoNameEnErrors: [],
        durationErrors: [],
        sortNumErrors: [],
      },
      showUid: false,
      showServiceId: false,
      showServiceType: false,
      showCreateTime: false,
      title: '新增视频',
      submitButtonStatus: true,
      videoUploadPercent: 0,
      videoFlag: false,
      ossFiles: [],
      originalName: '',
      loading: false,
      selectedUrl: '',
    }
  },
  created () {
    const params = this.$route.params
    if (params.videoId != null) {
      this.showId = true
      this.showUid = true
      this.showServiceId = true
      this.showServiceType = true
      this.showCreateTime = true
      this.title = '编辑视频'
      // 通过id获取详情
      videoApi.getVideo(params.videoId).then(response => {
        copyObject(response.video, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listOssLargeFile()
  },
  computed: {
    fields () {
      return [
        {
          name: 'originalName',
          title: '原名称',
          width: '25%',
        },
        {
          name: 'url',
          width: '25%',
        },
        {
          name: 'createTime',
          title: '同步时间',
          width: '25%',
        },
        {
          name: '__slot:actions',
          width: '25%',
          dataClass: 'text-left',
        },
      ]
    },
    formReady () {
      return !this.error.videoNameErrors.length &&
          !this.error.videoNameEnErrors.length &&
          !this.error.durationErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    listOssLargeFile () {
      const params = {
        originalName: this.originalName,
      }
      ossApi.listOssLargeFile(params).then(response => {
        this.ossFiles = response.ossFiles
        this.ossFiles.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    selectVideo (url) {
      this.insertData.videoUrl = url
      this.getVideoLength()
    },
    selectVideoEn (urlEn) {
      this.insertData.videoUrlEn = urlEn
    },
    search: debounce(function (originalName) {
      this.originalName = originalName
      this.listOssLargeFile()
    }, 400),
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.videoUrl.length === 0) {
        this.showToast('请选择中文视频', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      if (this.insertData.videoUrlEn.length === 0) {
        this.showToast('请选择英文视频', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        videoName: this.insertData.videoName,
        videoNameEn: this.insertData.videoNameEn,
        videoId: this.insertData.videoId,
        duration: this.insertData.duration,
        videoUrl: this.insertData.videoUrl,
        videoUrlEn: this.insertData.videoUrlEn,
        serviceId: this.insertData.serviceId,
        serviceType: this.insertData.serviceType,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      if (this.insertData.videoId != null) {
        data.videoId = this.insertData.videoId
        videoApi.updateVideo(data.videoId, data).then(response => {
          if (response.success === true) {
            this.showToast('更新视频成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'updateFreeOpenCourse', params: { id: this.insertData.serviceId } })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        videoApi.saveVideo(data).then(response => {
          if (response.success === true) {
            this.showToast('添加视频成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'updateFreeOpenCourse', params: { id: this.insertData.serviceId } })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
        localStorage.setItem('percent', '0')
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.videoNameErrors = this.insertData.videoName ? [] : ['videoName is required']
      this.error.videoNameEnErrors = this.insertData.videoNameEn ? [] : ['videoNameEn is required']
      this.error.durationErrors = this.insertData.duration ? [] : ['duration is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    // uploadVideo () {
    //   if (this.insertData.videoUrlArr.length === 0) return
    //   this.getVideoLength()
    //   this.videoFlag = true
    //   const formData = new FormData()
    //   console.log(this.insertData.videoUrlArr)
    //   formData.append('type', 'video')
    //   formData.append('file', this.insertData.videoUrlArr[this.insertData.videoUrlArr.length - 1])
    //   const config = {
    //     onUploadProgress: ProgressEvent => {
    //       this.videoUploadPercent = (ProgressEvent.loaded / ProgressEvent.total * 100) | 0
    //     },
    //   }
    //   uploadApi.uploadImage(formData, config).then(response => {
    //     this.insertData.videoUrl = response.url
    //     this.showToast('添加视频成功', {
    //       duration: 1000,
    //       icon: 'fa-check',
    //       position: 'top-center',
    //       fullWidth: false,
    //     })
    //     this.videoFlag = false
    //     this.videoUploadPercent = 0
    //   }).catch(error => {
    //     this.showToast(error.msg, {
    //       duration: 1000,
    //       icon: 'fa-check',
    //       position: 'top-center',
    //       fullWidth: false,
    //     })
    //     this.videoFlag = false
    //     this.videoUploadPercent = 0
    //   })
    // },
    getVideoLength () {
      if (this.insertData.videoUrl === '') {
        this.insertData.duration = '0:00'
        return
      }
      const videoElement = new Audio(this.insertData.videoUrl)
      videoElement.addEventListener('`loadedmetadata`', () => {
        const minutes = Math.floor((videoElement.duration) / 60)
        const separator = ':'
        let seconds = Math.floor(videoElement.duration % 60)
        if (seconds < 10) {
          seconds = '0' + seconds
        }
        this.insertData.duration = minutes + separator + seconds
      })

      return false
    },
    async translateUnfilledFields () {
      // 视频名称
      if (this.insertData.videoName !== '' && this.insertData.videoNameEn === '') {
        this.insertData.videoNameEn = await translateData(this.insertData.videoName)
      }
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>

<!--
onUploadProgress: progressEvent => {
    if (progressEvent.lengthComputable) {
      const complete =
        (((progressEvent.loaded / progressEvent.total) * 100) | 0)
      if (complete >= 100) {
        localStorage.setItem('percent', '0')
      }
      localStorage.setItem('percent', complete)
    }
  },-->
